
<Popover @open="handleOpen" @close="handleClose">
    <template #trigger>
        <span class="license-popover-default-trigger">
            <slot name="trigger">{{ displayLicenseNumber }}</slot>
        </span>
    </template>
    <template #content="{ close }">
        <div class="license-popover-content" v-if="setCloseFunction(close)">
            <slot
                :close="close"
                :licenseNumber="displayLicenseNumber"
                :carId="carId"
                :carUuid="carUuid"
            >
                <div class="license-info">
                    <div class="license-name-row">
                        <div class="license-name">{{ displayLicenseNumber }}</div>
                    </div>
                    <div v-if="secondaryInfo" class="license-id">{{ secondaryInfo }}</div>
                </div>
            </slot>

            <div class="license-popover-actions">
                <Button
                    v-if="showRevenueButton"
                    v-tooltip="getRevenueTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageRevenue && isCarFiltered"
                    :class="{ 'current-page': isCurrentPageRevenue && isCarFiltered }"
                    @onClick="handleNavigate('revenue', close)"
                >
                    <i class="ri-money-dollar-circle-line"></i>
                    <span class="button-hotkey">U</span>
                </Button>

                <Button
                    v-if="showShiftsButton"
                    v-tooltip="getShiftsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageShifts && isCarFiltered"
                    :class="{ 'current-page': isCurrentPageShifts && isCarFiltered }"
                    @onClick="handleNavigate('shifts', close)"
                >
                    <i class="ri-repeat-line"></i>
                    <span class="button-hotkey">S</span>
                </Button>

                <Button
                    v-if="showTripsButton"
                    v-tooltip="getTripsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageTrips && isCarFiltered"
                    :class="{ 'current-page': isCurrentPageTrips && isCarFiltered }"
                    @onClick="handleNavigate('trips', close)"
                >
                    <i class="ri-steering-2-line"></i>
                    <span class="button-hotkey">E</span>
                </Button>

                <Button
                    v-if="showOperationRideButton"
                    v-tooltip="getOperationRideTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageOperationRide && isCarFiltered"
                    :class="{
                        'current-page': isCurrentPageOperationRide && isCarFiltered,
                    }"
                    @onClick="handleNavigate('operationride', close)"
                >
                    <i class="ri-route-line"></i>
                    <span class="button-hotkey">B</span>
                </Button>

                <Button
                    v-if="showCarsButton"
                    v-tooltip="getCarsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageCars && isCarFiltered"
                    :class="{ 'current-page': isCurrentPageCars && isCarFiltered }"
                    @onClick="handleNavigate('cars', close)"
                >
                    <i class="ri-car-line"></i>
                    <span class="button-hotkey">F</span>
                </Button>
            </div>

            <div v-if="$slots.actions" class="license-popover-custom-actions">
                <slot
                    name="actions"
                    :close="close"
                    :licenseNumber="displayLicenseNumber"
                    :carId="carId"
                    :carUuid="carUuid"
                />
            </div>
        </div>
    </template>
</Popover>
